import { render, staticRenderFns } from "./billDetail.vue?vue&type=template&id=2547f2ce&scoped=true&"
import script from "./billDetail.vue?vue&type=script&lang=js&"
export * from "./billDetail.vue?vue&type=script&lang=js&"
import style0 from "./billDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./billDetail.vue?vue&type=style&index=1&id=2547f2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547f2ce",
  null
  
)

export default component.exports